import { flow } from 'lodash';
import getContentStateWordCount from './get-content-state-word-count';
import wordCountToReadingTime from '@wix/communities-blog-universal/dist/src/utils/word-count-to-reading-time';

const getContentStateReadingTime = flow(
  getContentStateWordCount,
  wordCountToReadingTime,
);
export default getContentStateReadingTime;
